<template>
  <el-form
    size="small"
    ref="editForm"
    label-position="top"
    :model="scale"
    :rules="rules"
  >
    <el-row style="width: 100%" v-if="libraryType !== 'personal_competences'">
      <el-col>
        <el-form-item label="Вес" prop="weight">
          <el-input
            style="width: 100%"
            v-model="scale.weight"
            v-number-format
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row style="width: 100%" v-if="libraryType !== 'personal_competences' && libraryType !== 'library_key_indicators'">
      <el-col>
        <el-form-item label="Факт" prop="fact">
          <el-input
            :disabled="!isEdit"
            :placeholder="!isEdit ? 'Выбрать Факт будет возможно только после сохранения цели' : ''"
            style="width: 100%"
            v-model="scale.fact"
            v-number-format
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row style="width: 100%" v-if="libraryType !== 'personal_competences' && libraryType !== 'library_key_indicators'">
      <el-col>
        <el-form-item label="Оценка руководителя" prop="point_chief">
          <el-select
            v-model="scale.point_chief"
            style="width: 100%"
            no-data-text="Выберите результат"
          >
            <el-option
              v-for="pointChief in pointsChief"
              :key="pointChief.name"
              :value="pointChief.name"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row style="width: 100%" v-if="libraryType !== 'personal_competences'">
      <el-col>
        <el-form-item label="Даты выполнения">
          <click-to-edit
            v-model="scale.date_start"
            placeholder="Дата с"
            style="display: inline-block; width: 50%"
            type="date-picker"
            :date-picker-options="{firstDayOfWeek: 1}"
          ></click-to-edit>
          <click-to-edit
            v-model="scale.date_end"
            placeholder="Дата по"
            style="display: inline-block; width: 50%"
            type="date-picker"
            :date-picker-options="{firstDayOfWeek: 1}"
          ></click-to-edit>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import GroupsSelect from "@/components/groups/GroupsSelect.vue";
import ClickToEdit from "@/components/ClickToEdit.vue";

export default {
  name: "quantity-library-edit-form",
  mixins: [],
  components: {ClickToEdit, GroupsSelect},
  props: {
    libraryType: { type: String },
    scale: {type: Object, required: true},
    isEdit: {type: Boolean},
  },
  computed: {},
  watch: {},
  mounted() {},
  data() {
    return {
      rules: {},
      pointsChief: [
        {id: 1, name: 1},
        {id: 2, name: 2},
        {id: 3, name: 3},
        {id: 4, name: 4},
        {id: 5, name: 5},
      ],
    }
  },
  methods: {}
}
</script>

<style>

</style>